export interface ExternalLegalLink {
  label: string;
  href: string;
}

export const LEGAL_LINKS: ExternalLegalLink[] = [
  { label: 'Privacy policy', href: 'https://canadawaleyar.com/privacy' },
  { label: 'Terms of service', href: 'https://canadawaleyar.com/terms' },
  { label: 'EULA', href: 'https://canadawaleyar.com/eula' },
  { label: 'Data deletion', href: 'https://canadawaleyar.com/data-deletion' },
  { label: 'Legal disclaimers', href: 'https://canadawaleyar.com/disclaimer' },
  { label: 'Rewards program', href: 'https://canadawaleyar.com/rewards' },
];

export const LEGAL_LINKS_SHORT: ExternalLegalLink[] = [
  { label: 'Privacy', href: 'https://canadawaleyar.com/privacy' },
  { label: 'Terms', href: 'https://canadawaleyar.com/terms' },
  { label: 'Data deletion', href: 'https://canadawaleyar.com/data-deletion' },
];
